// MobileMenu.js
import { Link } from 'react-router-dom';

const MobileMenu = ({ 
  isOpen, 
  user, 
  notifications, 
  handleOpenLogin, 
  handleLogout, 
  setIsMobileMenuOpen 
}) => {
  if (!isOpen) return null;
  
  return (
    <nav className="md:hidden bg-white border-t border-gray-200">
      <ul className="flex flex-col py-2">
        <li>
          <Link to="/" className="block px-6 py-2 hover:bg-gray-100 uppercase text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
            Strona główna
          </Link>
        </li>
        <li>
          <Link to="/listings" className="block px-6 py-2 hover:bg-gray-100 uppercase text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
            Lista ogłoszeń
          </Link>
        </li>
        <li>
          <Link to="/about-company" className="block px-6 py-2 hover:bg-gray-100 uppercase text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
            O Firmie
          </Link>
        </li>
        {user && (
          <li>
            <Link to="/favorites" className="block px-6 py-2 hover:bg-gray-100 uppercase text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
              Ulubione
            </Link>
          </li>
        )}
        <li>
          <Link to="/contact" className="block px-6 py-2 hover:bg-gray-100 uppercase text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
            Kontakt
          </Link>
        </li>
        <li>
          {user ? (
            <Link to="/createlisting" className="block px-6 py-2 font-bold bg-gray-800 text-white uppercase hover:bg-gray-700" onClick={() => setIsMobileMenuOpen(false)}>
              Dodaj ogłoszenie
            </Link>
          ) : (
            <button onClick={handleOpenLogin} className="block w-full text-left px-6 py-2 font-bold bg-gray-800 text-white uppercase hover:bg-gray-700">
              Dodaj ogłoszenie
            </button>
          )}
        </li>
        {user ? (
          <>
            <li>
              <Link to="/user" className="block px-6 py-2 text-gray-800 uppercase hover:bg-gray-100" onClick={() => setIsMobileMenuOpen(false)}>
                Mój Profil
                {(notifications.messages + notifications.alerts > 0) && (
                  <span className="ml-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                    {notifications.messages + notifications.alerts}
                  </span>
                )}
              </Link>
            </li>
            <li>
              <button onClick={handleLogout} className="w-full text-left px-6 py-2 text-red-600 hover:bg-red-50 uppercase">
                Wyloguj się
              </button>
            </li>
          </>
        ) : (
          <>
            <li>
              <button onClick={handleOpenLogin} className="w-full text-left px-6 py-2 text-gray-800 uppercase hover:bg-gray-100">
                Zaloguj się
              </button>
            </li>
            <li>
              <Link to="/register" className="block px-6 py-2 text-gray-800 uppercase hover:bg-gray-100" onClick={() => setIsMobileMenuOpen(false)}>
                Zarejestruj się
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default MobileMenu;